import React from "react";
import * as masterservice from "../../services/master/master-service";
import * as taxIdService from "../../services/kyc/tax-id-service";
import { Authorize } from "../../components/authorize";
import * as Loader from "../../common/common";
import * as dates from "../../utils/date";
import DatePicker from "react-datepicker";
import * as validate from "../../utils/validations";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import "react-datepicker/dist/react-datepicker.css";
import { withRouterProps } from "../../common/hocs";

class TaxIdForm extends Authorize {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.onKeyPressDateValidation = this.onKeyPressDateValidation.bind(this);
  }

  state = {
    clientId: this.props.clientId,
    userType: this.props.clientType,
    taxTypes: [],
    taxDetails: [
      {
        taxId: undefined,
        taxType: "Pan No - 1",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "Excise Reg No - 6",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "Service Tax - 10",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "MSME Reg No - 7",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "VAT No - 3",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "8",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "CST No - 4",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "User - 9",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "ROC No - 5",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
      {
        taxId: undefined,
        taxType: "2",
        taxDesc: "",
        taxDate: "",
        taxDate1: "",
        error: "",
      },
    ],
  };

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let { response, err } = await commonDownloadPdfService.downloadTaxIds(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "TaxIds_" + clientId);
    }
  }

  handleInputChange(taxType, e) {
    let target = e.target;
    let value = target.value;
    let name = target.name;

    let details = Object.assign([], this.state.taxDetails);

    let modifiedTaxDetails = details.map((d) => {
      if (d.taxType === taxType) {
        if (name === "taxDesc") {
          d.taxDesc = value.toUpperCase();
        }
      }

      return d;
    });

    this.setState({
      taxDetails: modifiedTaxDetails,
    });
  }
  handleDateChange(taxType, txtName, date) {
    if (date !== undefined && date !== null && date !== "") {
      let details = Object.assign([], this.state.taxDetails);
      let modifiedTaxDetails = details.map((d) => {
        if (d.taxType === taxType) {
          d.taxDate1 = date;
          d.taxDate = dates.dateFormat(date);
          if (!validate.isValidDateFormat(d.taxDate)) {
            d.error = "Enter Limit Date in dd-mm-yyyy format";
          }
          d.error = "";
        }
        return d;
      });
      this.setState({
        taxDetails: modifiedTaxDetails,
      });
    }
  }

  onKeyPressDate(taxType, e) {
    if (e && e.target && typeof e.target.value === "string" && e.target.value.length > 10) {
      e.preventDefault();
      return false;
    }
    let details = Object.assign([], this.state.taxDetails);
    let modifiedTaxDetails = details.map((d) => {
      if (d.taxType === taxType) {
        d.taxDate = e.target.value;
        if (e.target.value && !validate.isValidDateFormat(d.taxDate)) {
          d.error = "Enter Limit Date in dd-mm-yyyy format";
        } else {
          d.error = "";
        }
      }
      return d;
    });
    this.setState({
      taxDetails: modifiedTaxDetails,
    });
  }
  validateFields() {
    let details = Object.assign([], this.state.taxDetails);
    let checkValidation = true;
    let updatedDetails = details.map((d) => {
      if (d.taxDate && !validate.isValidDateFormat(d.taxDate)) {
        d.error =
          "Please enter Limit Date in dd-mm-yyyy format for " + d.taxType;
        checkValidation = false;
      } else {
        d.error = "";
      }
      return d;
    });

    this.setState({
      taxDetails: updatedDetails,
    });
    return checkValidation;
  }

  async onSubmit(s, e) {
    if (!e) {
      e = s;
    }
    e.preventDefault();
    if (s && s === "prev") {
      if (this.state.userType === "Customer") {
        this.props.router.navigate(
          "/kycs/" +
            this.state.clientId +
            "/" +
            this.state.userType +
            "/addresses"
        );
      } else if (
        this.state.userType === "Supplier" ||
        this.state.userType === "CustomerSupplier"
      ) {
        this.props.router.navigate(
          "/kycs/" +
            this.state.clientId +
            "/" +
            this.state.userType +
            "/businessentity"
        );
      }
    } else {
      Loader.showLoader();
      let isSaved = false;
      let allowSubmit = this.validateFields();
      if (allowSubmit) {
        let clientId = this.state.clientId;
        const data = this.state.taxDetails.map((m) => {
          return Object.assign(
            {},
            {
              taxType: m.taxType,
              taxDesc: m.taxDesc,
              taxDate: m.taxDate,
              clientId: clientId,
              taxId: m.taxId,
            }
          );
        });
        let { response, err } = await taxIdService.saveTaxIds(data);
        Loader.hideLoader();
        if (err) {
          this.setState({
            error: err,
            msg: "",
          });
        } else if (response.data && response.data.err) {
          this.setState({
            error: response.data.err,
            msg: "",
          });
        } else {
          isSaved = true;
          this.setState({
            msg: response.data.msg,
            err: "",
          });
        }

        if (isSaved) {
          if (s && s === "next") {
            this.props.router.navigate(
              "/kycs/" +
                this.state.clientId +
                "/" +
                this.state.userType +
                "/accountanalysis"
            );
          } else {
            this.getTaxIds();
          }
        }
      } else {
        Loader.hideLoader();
      }
    }
  }

  async getTaxIdData() {
    Loader.showLoader();
    let { response, err } = await taxIdService.getClientInfo(
      this.state.clientId
    );
    if (err) {
      this.setState({
        message: "Error: " + err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: "Error: " + response.data.err,
      });
    } else {
      Loader.hideLoader();
      let updatedTaxDetails = this.state.taxDetails.map((t) => {
        if (t.taxType === "Pan No - 1") {
          t.taxDate = response.data.panDate
            ? dates.dateFormat(dates.StringToDate(response.data.panDate))
            : "";
          t.taxDate1 = response.data.panDate
            ? new Date(dates.StringToDate(response.data.panDate))
            : "";
          t.taxDesc = response.data.panNo;
        }
        if (t.taxType === "ROC No - 5") {
          t.taxDesc = response.data.rocNo;
        }
        if (t.taxType === "MSME Reg No - 7") {
          t.taxDesc = response.data.msmeNo;
        }
        return t;
      });
      this.setState({
        taxDetails: updatedTaxDetails,
      });
    }
  }

  async componentDidMount() {
    Loader.showLoader();
    let response = await masterservice.getMastersByGroup("TaxType");
    Loader.hideLoader();
    let taxTypesMaster =
      response && response.response && response.response.data;
    await this.getTaxIds();
    this.getTaxIdData();

    this.setState({
      taxTypes: taxTypesMaster,
    });
  }

  getAllData(d) {
    let arr = [];
    for (var i of d) {
      arr.push(i.taxType);
    }
    let data = this.state.taxTypes
      .filter((f) => {
        return arr.indexOf(f.name) === -1;
      })
      .map((m) => {
        return Object.assign(
          {},
          {
            taxType: m.name,
            taxDesc: "",
            taxDate: "",
            taxDate1: "",
            taxId: undefined,
            error: "",
          }
        );
      });
    return data;
  }

  async getTaxIds() {
    let clientId = this.state.clientId;
    Loader.showLoader();
    let taxIdData = await taxIdService.getTaxIds(clientId);
    Loader.hideLoader();
    if (
      taxIdData &&
      taxIdData.response &&
      taxIdData.response.data &&
      taxIdData.response.data.length > 0
    ) {
      let data = taxIdData.response.data.map((m) => {
        return Object.assign(
          {},
          {
            taxType: m.taxType,
            taxDesc: m.taxDesc,
            taxDate: m.taxDate
              ? dates.dateFormat(dates.StringToDate(m.taxDate))
              : "",
            taxDate1: m.taxDate ? new Date(dates.StringToDate(m.taxDate)) : "",
            taxId: m.taxId,
            error: "",
          }
        );
      });
      let d = this.getAllData(data);
      this.setState({
        taxDetails: data.concat(d),
      });
    } else {
      return;
    }
  }

  onKeyPressDateValidation = (e) => {
    if (validate.isValidKeyPressDate(e.which)) {
      e.preventDefault();
      return false;
    }
  };

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let taxDetailsDisplay = this.state.taxTypes.map((k, index) => {
      let taxObject = this.state.taxDetails.filter((t) => {
        return t.taxType === k.name;
      });

      return (
        <div key={k.code} className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor={k.name}>{k.name}</label>
                {k.name === "Pan No - 1" ||
                k.name === "ROC No - 5" ||
                k.name === "MSME Reg No - 7" ? (
                  <input
                    className="form-control"
                    type="text"
                    name="taxDesc"
                    value={taxObject.length > 0 && taxObject[0].taxDesc}
                    autoComplete="off"
                    readOnly
                  />
                ) : (
                  <input
                    className="form-control"
                    type="text"
                    onChange={this.handleInputChange.bind(this, k.name)}
                    name="taxDesc"
                    value={taxObject.length > 0 && taxObject[0].taxDesc}
                    autoComplete="off"
                  />
                )}
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor={k.name}>&nbsp;</label>

                {k.name === "Pan No - 1" ? (
                  <DatePicker
                    name="taxDate1"
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                    maxLength="10"
                    placeholderText="dd-mm-yyyy"
                    placeholder="dd-mm-yyyy"
                    selected={taxObject.length > 0 && taxObject[0].taxDate1}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={this.handleDateChange.bind(
                      this,
                      k.name,
                      "taxDate"
                    )}
                    onKeyDown={this.onKeyPressDate.bind(this, k.name)}
                    autoComplete="off"
                    // disabled={true}
                  />
                ) : (
                  <DatePicker
                    name="taxDate1"
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                    maxLength="10"
                    placeholderText="dd-mm-yyyy"
                    placeholder="dd-mm-yyyy"
                    selected={
                      taxObject.length > 0 ? taxObject[0].taxDate1 : new Date()
                    }
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChange={this.handleDateChange.bind(
                      this,
                      k.name,
                      "taxDate"
                    )}
                    onChangeRaw={this.onKeyPressDate.bind(this, k.name)}
                    onKeyDown={this.onKeyPressDateValidation}
                    autoComplete="off"
                  />
                )}
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group">
                <span className="error-msg ">
                  {taxObject.length > 0 && taxObject[0].error}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="container">
        <div className="row ">
          <div className="col-sm-12">
            <button
              className="float-right btn btn-md btn-info"
              title="Download PDF"
              onClick={this.downloadPdf.bind(this, this.state.clientId)}
            >
              <i className="fa fa-download"></i> PDF
            </button>
          </div>

          <div className="col-md-12 mb-2">
            {this.state.msg ? (
              <span className="msg-style-success">{this.state.msg}</span>
            ) : null}
            <form onSubmit={this.onSubmit}>
              <div className="row mt-5">
                <div className="col-sm-6">
                  <div className="row">
                    {/* <div className="col-sm-3"></div> */}
                    <div className="col-sm-6">
                      <h4>Tax Id</h4>
                    </div>
                    <div className="col-sm-6">
                      <h5>Limit Date /DOB/Date of Incorporation</h5>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="row">
                    {/* <div className="col-sm-6"></div> */}
                    <div className="col-sm-6">
                      <h4>Tax Id</h4>
                    </div>
                    <div className="col-sm-6">
                      <h5>Limit Date /DOB/Date of Incorporation</h5>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row  tax_form">{taxDetailsDisplay}</div>
              <div className="row ">
                <div className="col-sm-12">
                  <div style={{ textAlign: "center" }}>
                    {/* <input type="button" className="btn btn-primary btn-md" value="Go" onClick={this.switchTab} /> */}
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Previous"
                      onClick={this.onSubmit.bind(this, "prev")}
                    />
                    &nbsp;
                    <input
                      type="submit"
                      className="btn btn-primary"
                      value="Save"
                    />
                    &nbsp;
                    <input
                      type="button"
                      className="btn btn-primary"
                      value="Save and Next"
                      onClick={this.onSubmit.bind(this, "next")}
                    />
                    &nbsp;
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(TaxIdForm);